import { AxiosError } from 'axios';

export const isForbidden = (error: AxiosError) =>
  error.response && error.response.status === 403 ? true : false;
